import * as Yup from 'yup';

export const searchInventeringSchema = Yup.object().shape({
  aktivitetsnummer: Yup.string()
    .nullable()
    .test('Must start with a C', 'Inventeringsnummer måste börja med C', (value) => !value || value.startsWith('C'))
    .test(
      'Year must start with 19 or 20',
      'Årtal måste börja på 19 eller 20',
      (value) => !value || /^(C19|C20|C$)/g.test(value)
    )
    .test(
      'Must conform to format',
      'Inventeringsnummer ska ha följande format: CÅÅÅÅ-N',
      (value) => !value || /^C(19|20)\d{2}-\d+$/g.test(value)
    ),
  aktivitetstatustyper: Yup.array().nullable(),
  ansvarig_organisation: Yup.array().nullable(),
  lan_kod: Yup.array().when('aktivitetsnummer', () => Yup.array().nullable()),
  kommun_kod: Yup.array().when('aktivitetsnummer', () => Yup.array().nullable())
});

export interface SearchAktiviteterFormValues {
  aktivitetsnummer: string;
  aktivitetstatustyper: Array<string>;
  ansvarig_organisation: Array<string>;
  kommun_kod: Array<string>;
  lan_kod: Array<string>;
}
